import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const WarningIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.06 16.2997L15.39 3.57969C15.0798 3.09451 14.6525 2.69522 14.1475 2.41863C13.6424 2.14205 13.0758 1.99707 12.5 1.99707C11.9241 1.99707 11.3576 2.14205 10.8525 2.41863C10.3474 2.69522 9.92012 3.09451 9.60998 3.57969L1.93998 16.2997C1.66903 16.7513 1.52177 17.2664 1.51299 17.793C1.50421 18.3196 1.63423 18.8393 1.88998 19.2997C2.18566 19.818 2.61364 20.2484 3.13018 20.5471C3.64672 20.8458 4.2333 21.002 4.82998 20.9997H20.17C20.7627 21.006 21.3467 20.8559 21.8629 20.5644C22.379 20.273 22.8092 19.8505 23.11 19.3397C23.3732 18.8745 23.5074 18.3474 23.4986 17.8129C23.4898 17.2784 23.3384 16.756 23.06 16.2997ZM12.5 16.9997C12.3022 16.9997 12.1089 16.941 11.9444 16.8312C11.78 16.7213 11.6518 16.5651 11.5761 16.3824C11.5004 16.1997 11.4806 15.9986 11.5192 15.8046C11.5578 15.6106 11.653 15.4324 11.7929 15.2926C11.9327 15.1527 12.1109 15.0575 12.3049 15.0189C12.4989 14.9803 12.6999 15.0001 12.8827 15.0758C13.0654 15.1515 13.2216 15.2797 13.3314 15.4441C13.4413 15.6086 13.5 15.8019 13.5 15.9997C13.5 16.2649 13.3946 16.5193 13.2071 16.7068C13.0195 16.8943 12.7652 16.9997 12.5 16.9997ZM13.5 12.9997C13.5 13.2649 13.3946 13.5193 13.2071 13.7068C13.0195 13.8943 12.7652 13.9997 12.5 13.9997C12.2348 13.9997 11.9804 13.8943 11.7929 13.7068C11.6053 13.5193 11.5 13.2649 11.5 12.9997V8.99969C11.5 8.73448 11.6053 8.48012 11.7929 8.29259C11.9804 8.10505 12.2348 7.99969 12.5 7.99969C12.7652 7.99969 13.0195 8.10505 13.2071 8.29259C13.3946 8.48012 13.5 8.73448 13.5 8.99969V12.9997Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default WarningIcon;
